<template>
<div class="component">

    <div class="questionContainer">
        <div class="question">
            <p class="">
                {{question.question}}
            </p>
        </div>
        <div class="answerBox">

            <div class="content givenAnswers" v-if="question.questionType==0">
                <div class="multipleChoiceAnswers">
                    <div class="answer" v-for="answer in question.answers" @click="chooseAnswer(answer.id)" :class="{'choosenAnswer':questionAnswer==answer.id}">
                        <span class="answerText"> {{answer.answerText}}</span>
                        <span class="answerMark">{{answer.percentage || 0}} %</span>

                    </div>
                </div>
            </div>

            <div class="content givenAnswers" v-if="question.questionType==1">
                <h1 class="title">{{$t('enaq_translation_surveys_residents_answer')}}</h1>
                <div class="customAnswerCarousel">
                    <div class="customAnswerCarouselArrow"><i class="fas fa-chevron-left" @click="customAnswerIndex--"></i></div>
                    <div class="customAnswer">{{customCarouselAnswer}}</div>
                    <div class="customAnswerCarouselArrow" @click="customAnswerIndex++"><i class="fas fa-chevron-right"></i></div>

                </div>
            </div>

            <div class="content givenAnswers" v-if="question.questionType==2">
                <div class="resultNumbers columns is-mobile is-multiline">
                    <span class="column is-8">{{$t('enaq_translation_surveys_average_answer')}}</span><span class="column is-4"> {{question.result}}</span>

                </div>
            </div>
        </div>
        <hr>
    </div>
    <!--
    <div class="card">
        <header class="card-header" @click="openModal = !openModal">
            <p class="card-header-title">
                {{question.question}}
            </p>

        </header>
        <div class="card-content" v-if="openModal">

            <div class="content givenAnswers" v-if="question.questionType==0">
                <div class="list is-hoverable">
                    <table class="table">
                        <thead>
                            <td width="80%">Antwort</td>
                            <td>Verteilung</td>
                        </thead>
                        <tr v-for="answer in answers">
                            <td width="80%">{{answer.answerText}}</td>
                            <td>{{answer.percentage || 0}} %</td>
                        </tr>
                    </table>

                </div>
            </div>

            <div class="content givenAnswers" v-if="question.questionType==1">
                <h1 class="title">Antworten der Bewohner:</h1>
                <div class="list is-hoverable">
                    <a class="list-item" v-for="answer in question.result">
                        {{answer.customAnswerText}}
                    </a></div>
            </div>

            <div class="content givenAnswers" v-if="question.questionType==2">
                <div class="resultNumbers columns is-mobile is-multiline">
                    <span class="column is-8">Die durchschnittliche Bewohnerantwort lautet:</span><span class="column is-4"> {{question.result}}</span>

                </div>
            </div>

        </div>
        <footer class="card-footer">
        </footer>
    </div>

    -->
</div>
</template>

<script>
export default {
    name: 'questionResult',
    props: ["question"],
    mounted: function () {
        this.parseAnswers();
    },
    data() {
        return {
            data: [],
            openModal: false,
            answers: [],
            customAnswers: [],
            customAnswerIndex: 0
        }
    },
    methods: {
        parseAnswers() {
            this.answers = this.question.answers;

            for (var answerID in this.answers) {
                for (var resultId in this.question.result) {
                    if (this.question.result[resultId].survey_answer_id == this.answers[answerID].id) {
                        this.answers[answerID].percentage = Math.round(this.question.result[resultId].percentage * 1000) / 10
                    }
                }
                if (this.answers[answerID].percentage == undefined) {
                    this.answers[answerID].percentage = 0;
                }

            }

            this.answers.sort(function (a, b) {
                return b.percentage - a.percentage;
            });
        }
    },
    computed: {
        customCarouselAnswer() {
            if (this.customAnswerIndex < 0) {
                this.customAnswerIndex = this.question.result.length - 1;
            }

            if (this.customAnswerIndex >= this.question.result.length) {
                this.customAnswerIndex = 0;
            }

            return this.question.result[this.customAnswerIndex].customAnswerText
        }
    },
}
</script>

<style scoped>
.choosenAnswer {
    background: lightgrey;
}

.sendButton {
    margin-top: 10px;
}

.choosenAnswer {}

.sendButton {
    margin-top: 10px;
}

.questionContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;
}

.question {
    display: inline-block;
    width: 50%;
    -webkit-box-shadow: 0px 0px 5px 3px rgba(0, 0, 0, 0.38);
    -moz-box-shadow: 0px 0px 5px 3px rgba(0, 0, 0, 0.38);
    box-shadow: 0px 0px 5px 3px rgba(0, 0, 0, 0.38);
    margin: 1vh 0;
    font-size: 2em;
    border-radius: 40px;
    padding: 10px;
    height: 100%;
}

.answerBox {
    display: inline-block;
    width: 50%;
    padding-left: 5%
}

.multipleChoiceAnswers {
    border-top: 1px solid grey;
    margin: 0 1vw;
}

.multipleChoiceAnswers .answer {
    display: block;
    font-size: 1.8em;
    border-bottom: 1px solid grey;
    padding: 5px 0;
}

.multipleChoiceAnswers .answerText {
    display: inline-block;
    width: 80%;

}

.multipleChoiceAnswers .answerMark {
    display: inline-block;
    width: 20%;

}

.customTextAnswer,
.customNumberAnswer {
    padding: 0 20px;
    padding-top: 2em;
}

.resultNumbers {
    font-size: 1.5em;
}

.customAnswer {
    display: inline-block;
    width: 80%;
}

.customAnswerCarousel {
    padding:20px;
    border-top: 1px solid grey;
        border-bottom: 1px solid grey;

        font-size: 1.5em;

}

.customAnswerCarouselArrow {
    display: inline-block;
    width: 10%;
    cursor:pointer;
}
</style>
